'use client'

import { useCallback, ReactNode } from 'react'
import useEmblaCarousel from 'embla-carousel-react'
import { EmblaOptionsType } from 'embla-carousel'

interface EmblaCarouselProps {
  children: ReactNode
  options?: EmblaOptionsType
  renderButtons?: (scrollPrev: () => void, scrollNext: () => void) => ReactNode
  className?: string
}

const EmblaCarousel: React.FC<EmblaCarouselProps> = ({ children, options, renderButtons, className }) => {
  const [emblaRef, emblaApi] = useEmblaCarousel(options)

  const scrollPrev = useCallback(() => emblaApi && emblaApi.scrollPrev(), [emblaApi])
  const scrollNext = useCallback(() => emblaApi && emblaApi.scrollNext(), [emblaApi])

  return (
    <div className="relative w-full">
      {/* Embla Viewport */}
      <div className="overflow-hidden" ref={emblaRef}>
        <div className={`flex ${className}`}>{children}</div>
      </div>

      {/* Custom Button Renderer */}
      {renderButtons && renderButtons(scrollPrev, scrollNext)}
    </div>
  )
}

export default EmblaCarousel
